import {FC, useState, useEffect, Fragment} from 'react'

type Props = {
  name: string
  title: string
  handleInput: any
  defaultValue: any
  readOnly: boolean
  defaultDataNote: any
  errors: any
}

const NoteContent: FC<Props> = ({
  name,
  title,
  handleInput,
  defaultValue,
  readOnly,
  defaultDataNote,
  errors,
}) => {
  const [value, setValue] = useState('')

  useEffect(() => {
    setValue(defaultValue)
  }, [defaultValue])

  const valueInput = (value: any) => {
    setValue(value)
    handleInput(name, value)
  }

  return (
    <div className='card'>
      <div className='p-7 border-bottom'>
        <div className='d-flex align-items-center gap-3'>
          <div className='icon-box px-4 py-2 rounded' style={{backgroundColor: '#EBF3FA'}}>
            <i className='fa fa-info-circle text-dark'></i>
          </div>
          <p className='fs-4 fw-bold'>{title}</p>
        </div>
      </div>
      <div className='p-8'>
        {defaultDataNote == 0 ? (
          <div>
            <p className='mb-2'>
              {title} <span className='text-danger fw-bold'>*</span>
            </p>
            <textarea
              onChange={(e) => valueInput(e.target.value)}
              className='form-control'
              value={value}
              readOnly={readOnly}
            ></textarea>

            {errors?.[name] ? <p className='text-danger'>{errors?.[name]}</p> : null}
          </div>
        ) : (
          defaultDataNote?.map((item: any, index: number) => {
            if (!item?.nama_penilai) {
              return ''
            }

            return (
              <div className={index > 0 ? 'mt-5' : ''}>
                <p className='mb-2'>{item?.nama_penilai}</p>
                <textarea className='form-control' value={item?.catatan} readOnly={true}></textarea>
              </div>
            )
          })
        )}
      </div>
    </div>
  )
}

const Note: FC<Props> = ({
  name,
  title,
  handleInput,
  defaultValue,
  readOnly,
  defaultDataNote,
  errors,
}) => {
  return (
    <NoteContent
      name={name}
      title={title}
      handleInput={handleInput}
      defaultValue={defaultValue}
      readOnly={readOnly}
      defaultDataNote={defaultDataNote}
      errors={errors}
    />
  )
}

export default Note
